// extracted by mini-css-extract-plugin
export default {"container":"ConsentShareDataToInsurerHistory_container__Vidyy"};